/** @prettier */

import {ListItemIcon, Menu, MenuItem, MenuProps, Box} from '@mui/material';
import {useTranslation} from 'react-i18next';

/**
 * 特定日セレクトメニュー
 * @param props props
 * - id メニューごとで一意のID
 * - menuPosition メニュー表示位置
 * - open メニュー開閉
 * - clickMenuItem メニュー押下時処理
 * @returns JSX
 */
export const SelectTypeMenu = (props: {
  id: MenuProps['id'];
  menuPosition: MenuProps['anchorEl'];
  open: MenuProps['open'];
  clickMenuItem(num?: number): void;
}) => {
  const trans = useTranslation().t; //翻訳関数

  return (
    <Menu
      id={props.id}
      anchorEl={props.menuPosition}
      open={props.open}
      onClose={() => {
        props.clickMenuItem();
      }}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}>
      <MenuItem onClick={() => props.clickMenuItem(0)}>
        <ListItemIcon>
          <Box className="schedule__menuItem__icon__weekday" />
        </ListItemIcon>
        <Box className="schedule__menuItem__text">
          {trans('SelectTypeMenuList.menuItem.weekday')}
        </Box>
      </MenuItem>
      <MenuItem onClick={() => props.clickMenuItem(1)}>
        <ListItemIcon>
          <Box className="schedule__menuItem__icon__holiday" />
        </ListItemIcon>
        <Box className="schedule__menuItem__text">
          {trans('SelectTypeMenuList.menuItem.holiday')}
        </Box>
      </MenuItem>
      <MenuItem onClick={() => props.clickMenuItem(2)}>
        <ListItemIcon>
          <Box className="schedule__menuItem__icon__specialDay1" />
        </ListItemIcon>
        <Box className="schedule__menuItem__text">
          {trans('SelectTypeMenuList.menuItem.specialDay1')}
        </Box>
      </MenuItem>
      <MenuItem onClick={() => props.clickMenuItem(3)}>
        <ListItemIcon>
          <Box className="schedule__menuItem__icon__specialDay2" />
        </ListItemIcon>
        <Box className="schedule__menuItem__text">
          {trans('SelectTypeMenuList.menuItem.specialDay2')}
        </Box>
      </MenuItem>
    </Menu>
  );
};
